import { dateToIsoDateString } from "@/utils/utils";
import { Calendar, Col, Row, Select } from "antd";
import { Dayjs } from "dayjs";
import styles from "./CalendarPanel.module.scss";

const renderCalendarHeader = (value: Dayjs, onChange: (date: Dayjs) => void) => {
  const year = value.year();

  const yearOptions = Array.from({ length: 20 }, (_, i) => {
    const y = year - 10 + i;
    return { value: y, label: y };
  });

  const handleYearChange = (newYear: number) => onChange(value.clone().year(newYear));
  const handleMonthChange = (newMonth: number) => onChange(value.clone().month(newMonth));

  return (
    <div style={{ padding: 8 }}>
      <Row gutter={8} justify="end">
        <Col>
          <Select
            size="small"
            popupMatchSelectWidth={false}
            value={year}
            onChange={handleYearChange}
            options={yearOptions}
          />
        </Col>
        <Col>
          <Select
            size="small"
            popupMatchSelectWidth={false}
            value={value.month()}
            onChange={handleMonthChange}
            options={Array.from({ length: 12 }, (_, i) => ({
              value: i,
              label: value.localeData().monthsShort(value.clone().month(i)),
            }))}
          />
        </Col>
      </Row>
    </div>
  );
};

type Props = {
  data?: { [key: string]: any[] };
  value: Dayjs;
  onChange: (date: Dayjs) => void;
  style?: React.CSSProperties;
};

export const CalendarPanel = ({ data, value, onChange, style }: Props) => {
  return (
    <Calendar
      style={style}
      className={styles.calendar}
      fullscreen={false}
      mode="month"
      value={value}
      cellRender={(date) =>
        data?.[dateToIsoDateString(date)]?.length ? <div className={styles.cellHighlight} /> : undefined
      }
      headerRender={({ value, onChange }) => renderCalendarHeader(value, onChange)}
      onChange={onChange}
      onPanelChange={onChange}
    />
  );
};
